import React from "react";
import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  Image,
  Tooltip,
  useBreakpointValue,
} from "@chakra-ui/react";
import { FaShieldAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import UserAccountMenu from "./UserAccountMenu";
import logo from "../assets/logos/logo.png";
import { useLanguage } from "../contexts/LanguageContext";
import { UserAuth, resolveLandingPath } from "../contexts/AuthContext";

const Navbar = ({ external = false, supportedLanguages }) => {
  const logoSize = useBreakpointValue({ base: "150px", md: "150px" });
  const { language, setLanguage } = useLanguage();
  const { user } = UserAuth();
  const navigate = useNavigate();

  const showLanguageToggle =
    !Array.isArray(supportedLanguages) || supportedLanguages.length > 1;

  // Mimic the initial post-sign-in landing: re-evaluate the routing rule and
  // hard-reload so the destination starts from a clean slate.
  const handleLogoClick = () => {
    const target = external || !user ? "/" : resolveLandingPath(user);
    window.location.assign(target);
  };

  return (
    <Box as="nav" bg="white" boxShadow="sm" py={5} width="100%">
      <Flex
        justify="space-between"
        align="center"
        maxW="1200px"
        mx="auto"
        px={4}
      >
        <Button
          onClick={handleLogoClick}
          variant="unstyled"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image src={logo} alt="Logo" w={logoSize} h="auto" />
        </Button>
        {external ? (
          showLanguageToggle ? (
            <Flex align="center">
              <Box
                as="button"
                py={2}
                px={2}
                onClick={() => setLanguage("en")}
                color={language === "en" ? "black" : "gray.500"}
                fontWeight={language === "en" ? "bold" : "normal"}
              >
                EN
              </Box>
              <Box px={0.5} color="gray.300">
                |
              </Box>
              <Box
                as="button"
                py={2}
                px={2}
                onClick={() => setLanguage("fr")}
                color={language === "fr" ? "black" : "gray.500"}
                fontWeight={language === "fr" ? "bold" : "normal"}
              >
                FR
              </Box>
            </Flex>
          ) : null
        ) : (
          <HStack spacing={2}>
            {user?.isPlatformAdmin && (
              <Tooltip label="Platform Dashboard" hasArrow>
                <IconButton
                  aria-label="Platform Dashboard"
                  icon={<FaShieldAlt />}
                  variant="outline"
                  colorScheme="purple"
                  size="sm"
                  onClick={() => navigate("/admin")}
                />
              </Tooltip>
            )}
            <UserAccountMenu />
          </HStack>
        )}
      </Flex>
    </Box>
  );
};

export default Navbar;
